import React from 'react'
import {motion} from 'framer-motion'
import {AppWrap, MotionWrap} from '../../wrapper'
import './WhyChooseUs.scss'

const WhyChooseUs = () => {
  const reasons = [
    {
      id: 1,
      title: 'Cross-Disciplinary Expertise',
      description: 'Deep expertise across education, business, and technology with proven solutions.',
      icon: '🎯'
    },
    {
      id: 2,
      title: 'African Market Intelligence',
      description: 'Strong understanding of African markets and user behavior for strategic advantage.',
      icon: '🌍'
    },
    {
      id: 3,
      title: 'End-to-End Delivery',
      description: 'Complete support from concept to execution with focus on innovation and design thinking.',
      icon: '🚀'
    },
    {
      id: 4,
      title: 'Results-Driven Approach',
      description: 'We don\'t just deliver services. We deliver results, clarity, and long-term value.',
      icon: '💎'
    }
  ]

  return (
    <div className='app__why-choose-wrapper-upper'>
      <motion.h2 
        whileInView={{opacity: [0, 1]}}
        transition={{duration: 0.6}}
        className='head-text'
      >
        Why Choose <span>Scoolj Institute</span>?
      </motion.h2>
      
      <div className='app__why-choose-wrapper'>
        <div className='app__why-choose-container'>
          {reasons.map((reason, index) => (
            <motion.div
              whileInView={{opacity: [0, 1], y: [50, 0]}}
              transition={{duration: 0.5, delay: index * 0.1}}
              className='app__why-choose-item app__flex'
              key={reason.id}
            >
              <div className='app__why-choose-icon'>
                <span>{reason.icon}</span>
              </div>
              <div className='app__why-choose-content'>
                <h4 className='bold-text'>{reason.title}</h4>
                <p className='p-text'>{reason.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className='app__why-choose-summary'>
          <motion.p 
            whileInView={{opacity: [0, 1]}}
            transition={{duration: 0.7, delay: 0.5}}
            className='p-text app__why-choose-tagline'
          >
            <span className='bold-text'>A team of creative thinkers, developers, researchers, and strategists</span> committed to excellence and long-term client success.
          </motion.p>
        </div>
      </div>
    </div>
  )
}

export default AppWrap(
  MotionWrap(WhyChooseUs, 'app__why-choose'),
  'why-choose',
  'app__whitebg'
)